export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Drilling & Well Engineering Educator — London, United Kingdom',
    'My students finally understand the difference between well planning, drilling systems, casing and cementing, and well control fundamentals. I used to waste hours searching for the right way to explain how drilling and well engineering actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain well trajectories, drilling fluids, pressure management, well barriers, troubleshooting, or how to teach engineering reasoning in drilling contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Drilling & Well Engineering and Operations Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated drilling and well engineering projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Drilling & Well Engineering Educator | London, United Kingdom',
    "The material on well planning and well control completely changed how my students understand drilling engineering. They finally grasp how pressure management and well barriers prevent incidents. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Drilling & Well Engineering Teacher | Berlin, Germany',
    "The 50 drilling and well engineering projects transformed how my students see real-world applications. Now they analyze well plans, understand rig systems, evaluate drilling problems, and grasp why drilling knowledge matters professionally and in real well operations. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The drilling and well engineering terminology handbook gave me back my class time. I used to spend time explaining drilling concepts and misconceptions. Now I show the handbook and students instantly understand drilling and well engineering concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Drilling & Well Engineering Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real drilling challenges, evaluating well construction decisions, exploring troubleshooting scenarios, and understanding how engineering reasoning contributes to well safety and integrity. This completely transformed how they see drilling and well engineering.",
  ],
];
